import React from 'react';

import useEducational from 'features/educational/useEducational';
import styled from 'styled-components';
import { Flex, Typography } from 'components';

const BatchProduct = styled.div`
  width: 100px;
  height: 140px;
  background-image: url(${(props: any) => props['data-image']});
  background-size: cover;
  background-position: center;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.gray_300};
`;

const BatchProducts = () => {
  const {
    activateCode: { productClasses },
  } = useEducational();

  if (!productClasses?.length) return null;

  return (
    <Flex flexDirection="column" style={{ gap: 6 }} mt={4}>
      <Typography color="gray_600" fontWeight="medium">
        Material didático
      </Typography>

      <Flex style={{ gap: 16 }}>
        {productClasses?.map((product) => (
          <BatchProduct key={`material-${product.productClassUuid}`} data-image={product.cardImageUrl} />
        ))}
      </Flex>
    </Flex>
  );
};

export default BatchProducts;
